import { normalizeReleaseName } from '../../../api/src/shared/releaseMetadata/normalize';

type BuildReleaseNftNameInput = {
  localizedName?: string | null;
  dappName?: string | null;
  versionName?: string | null;
  fallbackName?: string;
};

type BuildReleaseDisplayNameInput = Omit<
  BuildReleaseNftNameInput,
  'versionName'
>;

const trimToUndefined = (value?: string | null) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

export function buildReleaseNftName({
  localizedName,
  dappName,
  versionName,
  fallbackName = 'Release update',
}: BuildReleaseNftNameInput): string {
  const baseName =
    trimToUndefined(localizedName) || trimToUndefined(dappName) || fallbackName;
  const version = trimToUndefined(versionName);

  return normalizeReleaseName(version ? `${baseName} v${version}` : baseName);
}

export function buildReleaseDisplayName({
  localizedName,
  dappName,
  fallbackName = 'Release update',
}: BuildReleaseDisplayNameInput): string {
  const baseName =
    trimToUndefined(localizedName) || trimToUndefined(dappName) || fallbackName;

  return normalizeReleaseName(baseName);
}
